import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { Card, CardContent } from "@/components/ui/card";

export default function PendingApproval() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo className="h-12" />
        </div>
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="p-8 text-center">
            <div className="mx-auto w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
              <Clock className="w-7 h-7 text-amber-600" />
            </div>
            <h1 className="text-2xl font-heading font-bold text-slate-900 mb-2">Aguardando aprovação</h1>
            <p className="text-slate-600 mb-6">
              Seu cadastro foi enviado com sucesso. Um administrador irá revisar
              e aprovar seu acesso em breve.
            </p>
            <Link to="/login" data-testid="pending-back-to-login" className="text-[#FF8A50] hover:underline font-medium">
              Voltar ao login
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
